module.exports = __webpack_public_path__ + "img/013.c7fb9b33.png";